<template>
  <section class="filter-wrap base-shadow">
    <el-form ref="form" :model="tableFilters" label-width="auto">
      <el-row :gutter="20">
        <el-col :sm="24" :md="12" :lg="8">
          <el-form-item label="名称">
            <el-input
              v-model="tableFilters.name"
              placeholder="请输入"
              clearable
              @keyup.enter.native="onSearch"
              @clear="onSearch"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="8">
          <el-form-item label="用户登录名">
            <el-input
              v-model="tableFilters.username"
              placeholder="请输入"
              clearable
              @keyup.enter.native="onSearch"
              @clear="onSearch"
            ></el-input>
          </el-form-item>
        </el-col>

        <template v-if="showMoreFilter">
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="激活状态">
              <BasicSelect
                v-model="tableFilters.activated"
                :allOptions="activatedOptions"
              />
            </el-form-item>
          </el-col>

          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="角色">
              <BasicSelect
                v-model="tableFilters.role_ids"
                keyName="name"
                :allOptions="rolesOptions"
              />
            </el-form-item>
          </el-col>

          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="创建日期">
              <el-date-picker
                v-model="tableFilters.utc_create"
                type="daterange"
                style="width: 100%"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="最后修改日期">
              <el-date-picker
                v-model="tableFilters.utc_modified"
                type="daterange"
                style="width: 100%"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="创建人">
              <BasicAsyncSelect
                v-model="tableFilters.user_id_create"
                :asyncObj="{
                  dataFun: GetUsersList
                }"
              />
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="最后修改用户">
              <BasicAsyncSelect
                v-model="tableFilters.user_id_modified"
                :asyncObj="{
                  dataFun: GetUsersList
                }"
              />
            </el-form-item>
          </el-col>
        </template>
        <el-col :sm="24" :md="12" :lg="8">
          <el-form-item>
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="onResetFilter">重置</el-button>
            <el-button type="text" @click="showMoreFilter = !showMoreFilter">
              更多
              <i
                :class="
                  showMoreFilter ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                "
              ></i>
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </section>
</template>

<script>
import formSelection from "../mixins/formSelection";
import BasicSelect from "@/components/BasicSelect";
import BasicAsyncSelect from "@/components/BasicAsyncSelect";
import { onClearFilter } from "@/utils/common";
import { GetUsersList } from "@/views/users/api";
export default {
  components: {
    BasicSelect,
    BasicAsyncSelect
  },
  mixins: [formSelection],
  data() {
    return {
      showMoreFilter: false,
      activatedOptions: [
        { id: true, name: "已激活" },
        { id: false, name: "未激活" }
      ],
      tableFilters: {
        utc_create: [],
        utc_modified: [],
        user_id_create: null,
        user_id_modified: null,
        departmentId: null,
        activated: null,
        role_ids: [],
        name: "",
        phoneNo: "",
        username: ""
      },
      propObj: {}
    };
  },
  created() {
    this.initFormOptions();
  },
  methods: {
    GetUsersList,
    onSearch() {
      let filterParams = {};
      for (const key in this.tableFilters) {
        if (this.propObj[key]) {
          filterParams[this.propObj[key]] = this.tableFilters[key];
        } else {
          filterParams[key] = this.tableFilters[key];
        }
      }
      this.$emit("change", filterParams);
      this.$emit("confirm", filterParams);
    },
    onResetFilter() {
      this.tableFilters = onClearFilter(this.tableFilters);
      this.$emit("change", this.tableFilters);
      this.$emit("clear", this.tableFilters);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-input__inner {
    height: 42px;
    overflow: hidden;
  }
}
</style>
